import PropTypes from 'prop-types';
import { event } from '@zillow/universal-analytics';
export var NBANewLaneEvent = function NBANewLaneEvent(nbaNewLaneEventPayload) {
  event(nbaNewLaneEventPayload, {
    integrations: {
      gtm: false
    }
  });
};
NBANewLaneEvent.propTypes = {
  // eslint-disable-next-line zillow/react/forbid-prop-types
  nbaNewLaneEventPayload: PropTypes.object
};
NBANewLaneEvent.defaultProps = {
  nbaNewLaneEventPayload: {}
};